(function () {
    var instagramEmbedPromise = null;

    function loadInstagramEmbedScript() {
        if (window.instgrm && window.instgrm.Embeds) {
            return Promise.resolve();
        }

        if (instagramEmbedPromise) {
            return instagramEmbedPromise;
        }

        instagramEmbedPromise = new Promise(function (resolve) {
            var existingScript = document.querySelector('script[src*="instagram.com/embed.js"]');

            if (existingScript) {
                if (window.instgrm && window.instgrm.Embeds) {
                    resolve();
                    return;
                }

                existingScript.addEventListener('load', resolve, { once: true });
                existingScript.addEventListener('error', resolve, { once: true });
                window.setTimeout(resolve, 1500);
                return;
            }

            var script = document.createElement('script');
            script.src = 'https://www.instagram.com/embed.js';
            script.async = true;
            script.defer = true;
            script.addEventListener('load', resolve, { once: true });
            script.addEventListener('error', resolve, { once: true });
            document.body.appendChild(script);
        });

        return instagramEmbedPromise;
    }

    function processInstagramEmbeds() {
        if (window.instgrm && window.instgrm.Embeds && typeof window.instgrm.Embeds.process === 'function') {
            window.instgrm.Embeds.process();
        }
    }

    function scheduleInstagramEmbeds(sectionElement) {
        function loadAndProcess() {
            loadInstagramEmbedScript().then(processInstagramEmbeds);
        }

        if (!('IntersectionObserver' in window) || !sectionElement) {
            loadAndProcess();
            return;
        }

        if (sectionElement.dataset.instagramEmbedObserved === 'true') {
            return;
        }

        sectionElement.dataset.instagramEmbedObserved = 'true';

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    return;
                }

                observer.disconnect();
                loadAndProcess();
            });
        }, {
            rootMargin: '500px 0px'
        });

        observer.observe(sectionElement);
    }

    function initHomeInstagram(sectionElement) {
        if (!sectionElement || sectionElement.dataset.initialized === 'true') {
            scheduleInstagramEmbeds(sectionElement);
            return;
        }

        var sliderElement = sectionElement.querySelector('[data-home-instagram-swiper]');

        if (!sliderElement || typeof window.Swiper === 'undefined') {
            scheduleInstagramEmbeds(sectionElement);
            return;
        }

        sectionElement.dataset.initialized = 'true';

        var previousButton = sectionElement.querySelector('[data-home-instagram-prev]');
        var nextButton = sectionElement.querySelector('[data-home-instagram-next]');
        var slideCount = sliderElement.querySelectorAll('.swiper-slide').length;

        if (slideCount <= 1) {
            if (previousButton) {
                previousButton.hidden = true;
            }

            if (nextButton) {
                nextButton.hidden = true;
            }
        }

        new window.Swiper(sliderElement, {
            slidesPerView: 1.05,
            spaceBetween: 16,
            speed: 700,
            grabCursor: true,
            navigation: previousButton && nextButton && slideCount > 1 ? {
                prevEl: previousButton,
                nextEl: nextButton
            } : undefined,
            breakpoints: {
                750: {
                    slidesPerView: 2.1,
                    spaceBetween: 22
                },
                1100: {
                    slidesPerView: 3,
                    spaceBetween: 24
                }
            },
            on: {
                init: function () {
                    scheduleInstagramEmbeds(sectionElement);
                },
                slideChangeTransitionEnd: processInstagramEmbeds,
                resize: processInstagramEmbeds
            }
        });

        scheduleInstagramEmbeds(sectionElement);
    }

    window.filadelfiaHomeInstagram = {
        init: initHomeInstagram
    };
})();
